export default "__VITE_ASSET__DW97d4VB__"